<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
    >
      <v-tab @click="onTabClicked(item.id)" v-for="item in items"
        :key="item.id"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="1">
          <addres />
      </v-tab-item>
      <v-tab-item key="2">
          <ppn-cards />
      </v-tab-item>
      <v-tab-item key="3">
          <router-view />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import Addres from '@/components/glpm/addresComponent.vue'
import PpnCards from '@/components/glpm/ppnCards'
import VectorUpload from '@/components/vectorUpload'
export default {
  name: 'GlpmFindCards',
  components: {
    Addres,
    PpnCards,
    VectorUpload
  },
  data () {
    return {
      tab: null,
        items: [
          { id: 1, tab: 'Адрес'},
          { id: 2, tab: 'ППН'},
          { id: 3, tab: 'ЛПТ'},
        ],
    }
  },
  mounted: function () {
    
  },
  computed: {
  },
  methods: {
    getPpnCards() {
        this.$store.dispatch('getPpnCards')
    },
    onTabClicked(tab) {
      if(tab == 2) {
        this.getPpnCards()
      }
    }
  },
  watch: {
  }
}
</script>